import customHeaders, { getSpace } from '../../common/headers';
import vector_icon from './img/vector_icon.svg';
import banner_no_data from './img/banner-no-data.svg';
import calendar_icon from './img/calendar_icon.svg';
import { useParams, useLocation } from 'react-router-dom';
import { SendMessage } from '../../components/SendMessage/SendMessage';
import { useDataTable } from '../../common/hooks';
import { ModalAddToGroup } from '../../components/Modal/ModalAddToGroup/ModalAddToGroup';
import { ModalNewScenario } from '../../components/Modal/ModalNewScenario/ModalNewScenario';
import { ModalMassEditing } from '../../components/Modal/ModalMassEditing/ModalMassEditing';
import { ModalScenarioSettings } from '../../components/Modal/ModalScenarioSettings/ModalScenarioSettings';
import { ModalAddingReadyScenario } from '../../components/Modal/ModalAddingReadyScenario/ModalAddingReadyScenario';
import { useState, useEffect, useRef } from 'react';
import { ModalConfirmationUnloadingl } from '../../components/Modal/ModalConfirmationUnloading/ModalConfirmationUnloading';
import { ButtonActionDrop } from '../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { ModalConfirmingTemplateDeletion } from './ModalConfirmingTemplateDeletion/ModalConfirmingTemplateDeletion';
import { KonstantinFeedbackHttps } from '../../fetchUrls';
import ModalWarning from '../../components/Modal/ModalWarning/ModalWarning';
import {
  Tabs,
  TableBox,
  ButtonBasic,
  InputDynamicWidth,
  Checkbox,
  NoDataContent,
} from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import { useShallow } from 'zustand/react/shallow';
import './AutomationResponses.scss';
import { ButtonsSort } from '../../components/Buttons/BurronsSort/ButtonsSort';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { RequestController } from '../../common/filtersFunc';
import { fetchFilterV3 } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
const parse = require('html-react-parser')

const btn_sort = [
  { label: <span>A<br />Z</span>, value: 'answer' },
  { label: 'Дата', value: 'created_at' },
];

const btn_sort2 = [
  { label: <span>A<br />Z</span>, value: 'answer', value: 'group_name' },
  { label: 'Дата', value: 'created_at' },
];

const btn_tab_2 = [
  { label: 'Все', value: 'all' },
  { label: 'В группе', value: 'in_groups' },
  { label: 'Вне группы', value: 'outside_groups', },
];

const btn_tab_3 = [
  { label: 'В группе', value: 'false', counter: 0 },
  { label: 'Вне группы', value: 'true' },
];

const varaibles = {
  '@brand': {
    ui: 'Бренд',
    value: '@brand'
  },
  '@category': {
    ui: 'Категория',
    value: '@category'
  },
  // '@seller': {
  //     ui: 'Продавец',
  //     value: '@@Seller'
  // },
  '@product': {
    ui: 'Товар',
    value: '@product_name'
  },
  '@mp_name': {
    ui: 'Название маркетплейса',
    value: '@mp_name'
  },
}
// Левая панель - шаблон

export const TemplateGroupItem = ({
  hideAll,
  created_at,
  title,
  id,
  editGroup,
  selectGroup,
  isActiveGroup,
  setIsActiveGroup,
  editFunc,
  setSelectedGroupId,
  templates_count,
  setIsModalDeleteGroup,
  isEditGroup,
  setIsEditGroup
}) => {

  const [textContent, setIsTextContent] = useState(title);

  const handleEdit = () => {
    setIsActiveGroup(id);

    if (id == isEditGroup) {
      setIsEditGroup(null);
    } else {
      setIsEditGroup(id);
    }

    if (id == isEditGroup) {
      editGroup(id, textContent);
    }
  };

  useEffect(() => {
    setIsTextContent(title);
  }, [title]);

  const editFunk = () => {
    handleEdit();
    setIsActiveGroup(id);

    if (editFunc) {
      editFunc(title);
      setSelectedGroupId(id);
    }
  };

  const deleteFunc = () => {
    setIsActiveGroup(id)
    setIsModalDeleteGroup(true)
  }

  console.log(isActiveGroup)

  const btns = [
    { btn: 'Редактировать', func: (e) => editFunk() },
    { btn: 'Удалить', func: (e) => deleteFunc() },
  ];


  return (
    <div
      className={isActiveGroup == id ? 'template-gropp-item_active' : 'template-gropp-item'}
      onClick={(e) => {
        setIsActiveGroup(id);
        selectGroup(title, id);
      }}
    >
      <div className="info-box">
        {isEditGroup === id ? (
          <div className="info-box__row">
            <input
              style={{
                border: '1px solid lightgrey',
                borderRadius: '4px',
                padding: '2px'
              }}
              className="changed-title"
              value={textContent}
              onChange={(e) => setIsTextContent(e.target.value)}
              placeholder="Введите название"
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  handleEdit();
                }
              }}
            />
            <button className="info-box__btn"
              onClick={(e) => handleEdit()}
            >✓</button>
          </div>

        ) : (
          <h4 className="title">
            {textContent ? textContent : 'Нет названия'}
          </h4>
        )}
        <div className="template-gropp-item__bottom-info">
          <div className="template_count">
            <img src={vector_icon} />
            <p className="text">{`шаблонов ${templates_count ? templates_count : '-'
              }`}</p>
          </div>

          {!hideAll && (
            <>
              {created_at && (
                <div className="template_count">
                  <img src={calendar_icon} />
                  <p className="text">{`Дата создания: ${new Date(
                    created_at
                  )?.toLocaleDateString('ru-RU')}`}</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {id != -1 && <ButtonActionDrop id={id} btns={btns} />}
    </div>
  );
};
// Правая панель - элемент сообщения

export const MessageItem = ({
  created_at,
  updated_at,
  message,
  setValue,
  handleEdit,
  value,
  isEdit,
  view = 'Chat',
}) => {

  function highlightMentions(text) {
    return text.replace(/@\w+/g, (match) => {
      return `<span style="color: blue">${match}</span>`;
    });
  }

  return (
    <div className="template-message__content">
      {/* <p className='text'>{message}</p> */}
      {isEdit && view == 'Table' ? (
        <input
          style={{ padding: '.5em .75em', borderRadius: '.5em' }}
          className="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Введите название"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              handleEdit();
            }
          }}
        />
      ) : (
        <p className="text">{parse(highlightMentions(message))}</p>
      )}
      <div className="template-message__bottom-info">
        <p className="text_date">
          Создан {new Date(created_at)?.toLocaleDateString('ru-RU')}
        </p>
        <p className="text_date">
          Изменено {new Date(updated_at)?.toLocaleDateString('ru-RU')}
        </p>
      </div>
    </div>
  );
};

export const TemplateMessage = ({
  pageValue3,
  setAnswer,
  globalIsEdit,
  setGlobalIsEdit,
  id,
  setSelectedTemplateId,
  message,
  created_at,
  editTemplate,
  isActiveGroup,
  setIsModalAddToGroup,
  arrCheck,
  setArrCheck,
  selectedGroupId,
  updated_at,
  view,
  setIsModalConfirmingTemplateDeletion
}) => {
  const [value, setValue] = useState(message);
  const [isEdit, setIsEdit] = useState(false);

  const btns = [
    {
      btn: 'Добавить в группу',
      func: () => {
        if (arrCheck.length < 1) {
          setArrCheck([id]);
        }
        setIsModalAddToGroup(true);
      },
    },
    { btn: 'Редактировать шаблон', func: () => handleEdit() },
    {
      btn: 'Удалить шаблон',
      func: () => {
        setSelectedTemplateId(id)
        if (selectedGroupId !== -1 && pageValue3 == 'false') {
          setIsModalConfirmingTemplateDeletion(true)
          // deleteTemplate(id, group_id);
        } else {
          setIsModalConfirmingTemplateDeletion(true)
          // deleteTemplateInGroup(id);
        }
      },
    },
  ];

  const handleEdit = (e) => {
    setIsEdit(!isEdit);
    setGlobalIsEdit((state) => !state);
    setAnswer(message);
    setSelectedTemplateId(id);
    if (globalIsEdit) {
      editTemplate(id, value, selectedGroupId);
    }
  };

  return (
    <div className="template-message">
      {isActiveGroup != 'Все' && (
        <Checkbox
          value={arrCheck?.includes(id)}
          onChange={(e) => {
            let arr = [];
            if (arrCheck?.includes(id)) {
              arr = arrCheck.filter((el) => el != id);
              setArrCheck(arr);
            } else {
              setArrCheck((prev) => [...prev, id]);
            }
          }}
        />
      )}
      <div className="template-message__item">
        <MessageItem
          created_at={created_at}
          updated_at={updated_at}
          message={message}
          setValue={(e) => setValue(e)}
          handleEdit={(e) => handleEdit(e)}
          value={value}
          view={view}
          isEdit={isEdit}
        />

        <ButtonActionDrop id={id} btns={btns} />
      </div>
    </div>
  );
};

const AutomationResponses = ({
  openConnectionModalById,
  setQueryFeedbacks,
  page
}) => {
  const btn_tab = [
    {
      label: 'Шаблоны ответов',
      value: 'answer_templates',
    },
    {
      label: 'Сценарии с ИИ',
      value: 'prepared_scenarios',
    },
    ...(page == 'feedbacks')
      ? [
        {
          label: 'Ручные сценарии',
          value: 'custom_scenarios',
        }
      ] : []
  ];

  const {
    setIsModalNotificationsError,
    setCurrentFilterService,
    counterError,
  } = useGeneralStore(
    useShallow((state) => ({
      setIsModalNotificationsError: state.setIsModalNotificationsError,
      setCurrentFilterService: state.setCurrentFilterService,
      counterError: state.counterError
    }))
  );

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  const location = useLocation();
  const activeTab = useParams()['*'];


  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const [pageValue2, setPageValue2] = useState(btn_tab_2[0].value);
  const [pageValue3, setPageValue3] = useState(btn_tab_3[0].value);

  const [answerValue, setAnswerValue] = useState('');
  const [answer, setAnswer] = useState('');

  const [selectedTemplateId, setSelectedTemplateId] = useState(-1);

  const [searchInput, setSearchInput] = useState('');
  const [templateInput, setTemplateInput] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isEditScenario, setIsEditScenario] = useState(false);

  const [isModal, setIsModal] = useState(false);
  const [isModalScenarioSettings, setIsModalScenarioSettings] = useState(false);
  const [isModalMassEditing, setIsModalMassEditing] = useState(false);

  const [groupList, setGroupList] = useState([]);
  const [groupTemplates, setGroupTemplates] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(-1);
  const [selectedGroup, setSelectedGroup] = useState({});



  const [isNotOneAccount, setIsNotOneAccount] = useState('done');

  const [currentSort, setCurrentSort] = useState(null);

  const [sort2, setSort2] = useState(null);
  const [currentSort2, setCurrentSort2] = useState(null);

  const [isModalConfirmationUnloadingl, setIsModalConfirmationUnloadingl] = useState(false);
  const [isModalDeleteGroup, setIsModalDeleteGroup] = useState(false);
  const [isModalAddToGroup, setIsModalAddToGroup] = useState(false);
  const [isModalAddingReadyScenario, setIsModalAddingReadyScenario] = useState(false);
  const [isEditGroup, setIsEditGroup] = useState(null);

  const [view, setView] = useState('Chat');

  const [date, setDate] = useState(periodWeek());
  const [allPeriod, setAllPeriod] = useState(false);
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoadingg, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const { sort } = tableProps;

  const [scenarioData, setScenarioData] = useState({});
  const [selectedCategoryProperties, setSelectedCategoryProperties] = useState(
    {}
  );
  const [optionsGroup, setOptionsGroup] = useState([]);
  const [arrCheck, setArrCheck] = useState([]);
  const [currentId, setCurrentId] = useState(null);

  const [isModalEditGroup, setIsModalEditGroup] = useState(false);

  const [isOpenItemsUser, setIsOpenItemsUser] = useState(new Set());

  // Проверка страницы
  const is_answer = page == 'feedbacks'



  const fetchRuleTable = (params, pageValue = activeTab) => {
    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }

    let sortQuery = `?order_param=${sort?.[0]}&order_direction=${sort?.[1]}`;
    let pathData = pageValue === 'custom_scenarios' ? 'manual-rules' : 'category-rules';
    let url = `${KonstantinFeedbackHttps}/${page}/${pathData}/table${sort ? sortQuery : ''}`

    const body = JSON.stringify({
      page: paginatorRef?.current?.page,
      limit: paginatorRef?.current?.limit,
      filters,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError);
  };

  const fetchGroupList = () => {
    let query = '';
    let queryArr = [];

    if (searchInput?.length > 0) {
      queryArr.push(`search_param=${searchInput}`);
    }
    if (pageValue2) {
      queryArr.push(`template_filter=${pageValue2}`);
    }
    if (currentSort) {
      queryArr.push(`order_param=${currentSort?.value}`);
    }
    if (sort) {
      queryArr.push(`order_direction=${sort == 'ASC' ? 'ASC' : 'DESC'}`);
    }
    if (queryArr?.length > 0) {
      query = `?${queryArr.join('&')}&limit=100&offset=0`;
    }

    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups${query}`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        setGroupList(json);
        const optionList = json?.map((el) => {
          return {
            label: el.group_name,
            value: el.id,
          };
        });
        setOptionsGroup(optionList);
        if (selectedGroupId > -1) {
          selectGroup(selectedGroupId);
        } else {
          selectAllGroup(selectedGroupId);
        }
      })
      .catch(handleRequestError);
  };

  const createGroup = () => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups`

    const body = JSON.stringify({
      group_name: 'Новая группа',
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => fetchGroupList())
      .catch(handleRequestError);
  };

  const editGroup = (id, group_name) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups`

    const body = JSON.stringify({
      group_name,
      id,
    });

    fetch(url, { method: 'PUT', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        setGroupList((prev) => prev.map((el) => (el?.id === id ? json : el)));
        fetchGroupList();
      })
      .catch(handleRequestError);
  };

  const deleteGroup = (group_id) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups/${group_id}`

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then(() => {
        setSelectedGroupId(null)
        fetchGroupList();
      })
      .catch(handleRequestError);
  };

  const selectAllGroup = (group_id) => {
    // setSelectedGroupId(-1);
    let query = '';
    let queryArr = [];

    if (templateInput?.length > 0) {
      queryArr.push(`search_param=${templateInput}`);
    }
    if (pageValue2) {
      queryArr.push(`template_filter=${pageValue2}`);
    }
    if (currentSort2) {
      queryArr.push(`order_param=${currentSort2?.value}`);
    }
    if (sort2) {
      queryArr.push(`order_direction=${sort2 ? sort2 : 'ASC'}`);
    }
    if (queryArr?.length > 0) {
      query = `?${queryArr.join('&')}`;
    }

    let url = `${KonstantinFeedbackHttps}/${page}/answers/templates${query}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setGroupTemplates(json))
      .catch(handleRequestError);
  };

  const selectGroup = (group_id) => {
    setSelectedGroupId(group_id);
    let query = '';
    let queryArr = [];

    if (templateInput?.length > 0) {
      queryArr.push(`search_param=${templateInput}`);
    }
    if (pageValue3) {
      queryArr.push(`out_of_group=${pageValue3}`);
    }
    if (currentSort2) {
      queryArr.push(`order_param=${currentSort2?.value}`);
    }
    if (sort2) {
      queryArr.push(`order_direction=${sort2 ? sort2 : 'ASC'}`);
    }
    if (queryArr?.length > 0) {
      query = `?${queryArr.join('&')}`;
    }

    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups/${group_id}/templates${query}`

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setGroupTemplates(json))
      .catch(handleRequestError);
  };

  const createMassTemplate = (arr, selected_group) => {

    let curr_group = selected_group ? selected_group : selectedGroupId
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups/${curr_group}/templates`

    const body = JSON.stringify(
      arr.split(/\n\n/).map((el) => ({ answer: el }))
    );

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(() => {
        fetchGroupList()
        selectGroup(curr_group);
      })
      .catch(handleRequestError);
  };

  const deleteTemplate = (template_id, group_id) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups/${group_id}/templates/${template_id}`

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then(() => {
        fetchGroupList();
        if (selectedGroupId > -1) {
          selectGroup(group_id);
        } else {
          selectAllGroup(group_id);
        }
      })
      .catch(handleRequestError);
  };

  const deleteTemplateInGroup = (template_id) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/templates/${template_id}?confirmed_by_user=true`

    fetch(url, { method: 'DELETE', headers })
      .then(handleTableResponse)
      .then(() => {
        fetchGroupList();
        if (selectedGroupId > -1) {
          selectGroup(selectedGroupId);
        } else {
          selectAllGroup(selectedGroupId);
        }
      })
      .catch(handleRequestError);
  };

  const createTemplate = (arrTemplate) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/templates`

    const current_array = arrTemplate.map((el) => {
      return {
        answer: el
      }
    })

    const body = JSON.stringify(current_array);

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then(() => {
        if (selectedGroupId > -1) {
          selectGroup(selectedGroupId);
        } else {
          selectAllGroup(selectedGroupId);
        }
      })
      .catch(handleRequestError);
  };

  const editTemplate = (id, answer, group_id) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/templates`

    const body = JSON.stringify({
      answer,
      id,
    });

    fetch(url, { method: 'PUT', headers, body })
      .then(handleTableResponse)
      .then(() => {
        if (selectedGroupId > -1) {
          selectGroup(selectedGroupId);
        } else {
          selectAllGroup(selectedGroupId);
        }
      })
      .catch(handleRequestError);
  };

  const addToGroupTemplate = (group_id = [], template_list) => {
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups/${group_id}/templates/add`

    const body = JSON.stringify({
      template_id_list: template_list ? template_list : arrCheck,
    });

    fetch(url, { method: 'POST', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        setArrCheck = [];
        fetchGroupList();
      })
      .catch(handleRequestError);
  };

  const onEditRule = (ruleData) => {
    setIsEditScenario(true);
    if (pageValue == 'prepared_scenarios') {
      setIsModalAddingReadyScenario(true);
    } else {
      setIsModal(true);
    }
    setScenarioData(ruleData);
  };

  const deleteScenario = (id) => {
    if (id) {
      // 'feedbacks/front-rules/'
      const string_parametr =
        pageValue == 'prepared_scenarios' ? 'category-rules' : 'manual-rules';
      const url = `${KonstantinFeedbackHttps}/${page}/${string_parametr}/${id}`;

      fetch(url, { method: 'DELETE', headers })
        .then(handleTableResponse)
        .then(() => console.log('delete ' + id))
        .catch(handleRequestError);
    }
  };

  const onDeleteAccountHandler = (e) => {
    deleteScenario(e?.id);
    setTimeout(() => {
      // let pathData = pageValue === 'custom_scenarios' ? 'front-rules' : 'category-rules';
      fetchRuleTable([], activeTab);
    }, 600);
  };

  const contextMenuArr = [
    { label: 'Удалить', onClick: onDeleteAccountHandler },
  ];

  const changeStatusScenario = (id, status) => {
    if (id) {
      const string_parametr =
        pageValue == 'prepared_scenarios' ? 'category-rules' : 'manual-rules';
      const url = `${KonstantinFeedbackHttps}/${page}/${string_parametr}/${id}/status`;

      const body = JSON.stringify({
        active: status,
      });

      fetch(url, { method: 'PUT', headers, body })
        .then(handleTableResponse)
        .then((json) => console.log(json))
        .catch(handleRequestError);
    }
  };

  const onToggleStatus = (e) => {
    changeStatusScenario(e?.['Активно'][1], !e?.['Активно'][0]);
    setTimeout(() => {
      fetchRuleTable([], activeTab);
    }, 600);
  };

  useEffect(() => {
    setQueryFeedbacks(window?.location?.search)
  }, [window?.location?.search]);



  useEffect(() => {
    setPageValue(activeTab);
    setArrCheck([]);
    fetchRuleTable([], activeTab);
  }, [activeTab, page, isTableRequest]);

  useEffect(() => {
    setArrCheck([]);
  }, [pageValue2, pageValue3]);

  useEffect(() => {
    // fetchConnectionStatus()
    fetchGroupList();
  }, [
    searchInput,
    sort,
    currentSort,
    selectedSpace,
    searchInput,
    selectedGroupId
  ]);

  useEffect(() => {
    if (selectedGroupId > -1) {
      selectGroup(selectedGroupId);
    } else {
      selectAllGroup(selectedGroupId);
    }
  }, [
    selectedSpace,
    templateInput,
    selectedGroupId,
    pageValue3,
    pageValue2,
    isModalAddToGroup,
    sort2,
    currentSort2,
    pageValue3,
    templateInput
  ]);

  const sort_component = (current) => {
    let btn_sort_curr;
    let sort_curr;
    let setSort_curr;
    let setCurrentSort_curr;
    let btns_sort;

    if (current == 'group') {
      btns_sort = btn_sort2;
      btn_sort_curr = currentSort;
      sort_curr = sort;
      setSort_curr = setSort;
      setCurrentSort_curr = setCurrentSort;
    } else {
      btns_sort = btn_sort;
      btn_sort_curr = currentSort2;
      sort_curr = sort2;
      setSort_curr = setSort2;
      setCurrentSort_curr = setCurrentSort2;
    }

    return (
      <ButtonsSort
        btnSort={btns_sort}
        sort={sort_curr}
        setSort={setSort_curr}
        currentSort={btn_sort_curr}
        setCurrentSort={setCurrentSort_curr}
      />
    );
  };

  const input_search = (current, dependence) => {
    return (
      <InputDynamicWidth
        border={false}
        position="left"
        maxWidth="100%"
        isOpen={true}
        onChange={(value) => {
          if (current == 'group') {
            setSearchInput(value);
          } else {
            setTemplateInput(value);
          }
        }}
        placeholder={current == 'group' ? `Группы ${is_answer ? 'ответов' : 'вопросов'}` : `Шаблоны ${is_answer ? 'ответов' : 'вопросов'}`}
        clearDependence={dependence ? [dependence] : false}
      />
    );
  };

  const tabs_curr = () => {
    return selectedGroupId === -1 ? (
      <Tabs
        tabs={btn_tab_2}
        stopRedirect
        pageValue={pageValue2}
        setPageValue={(e) => setPageValue2(e)}
      />
    ) : (
      <Tabs
        tabs={btn_tab_3}
        stopRedirect
        pageValue={pageValue3}
        setPageValue={(e) => setPageValue3(e)}
      />
    );
  };

  const group_list = (func) => {
    return groupList?.map(
      ({ group_name, id, created_at, templates_count, updated_at }) => (
        <TemplateGroupItem
          isActiveGroup={selectedGroupId}
          setIsActiveGroup={(e) => setSelectedGroupId(e)}
          key={id}
          title={group_name}
          id={id}
          created_at={created_at}
          editGroup={editGroup}
          setIsModalDeleteGroup={setIsModalDeleteGroup}
          deleteGroup={(e) => deleteGroup(selectedGroupId)}
          selectGroup={(title, id) => {
            setSelectedGroup({
              label: title,
              value: id,
            });
            setSelectedGroupId(id);
            // selectGroup(id)
          }}
          editFunc={func}
          isModalEditGroup={isModalEditGroup}
          setIsModalEditGroup={(e) => setIsModalEditGroup(e)}
          templates_count={templates_count}
          updated_at={updated_at}
          isEditGroup={isEditGroup}
          setIsEditGroup={setIsEditGroup}
        />
      )
    );
  };

  const [isModalConfirmingTemplateDeletion, setIsModalConfirmingTemplateDeletion] = useState(false)

  useEffect(() => {
    setGroupTemplates([])
    setSelectedGroupId(groupList.length > 0 ? groupList[0]?.id : -1)
  }, [view])

  useEffect(() => {
    setSelectedGroupId(-1)
  }, [page]);

  return (
    <>
      {/* Удаление группы */}

      {isModalDeleteGroup &&
        <ModalWarning
          headerText='Подтвердите удаление'
          messageText={`Удалить группу?`}
          approveButtonText='Удалить'
          cancelButtonText='Отмена'
          colorBtn='red'
          onApproveClick={() => {
            deleteGroup(selectedGroupId)
            setIsModalDeleteGroup(false)
          }}
          onCancelClick={() => setIsModalDeleteGroup(false)}
        />}

      {/* Удаление шаблонов */}

      {isModalConfirmingTemplateDeletion &&
        <ModalConfirmingTemplateDeletion
          setIsModal={setIsModalConfirmingTemplateDeletion}
          deleteTemplateInGroup={deleteTemplateInGroup}
          deleteTemplate={deleteTemplate}
          selectedGroupId={selectedGroupId}
          selectedTemplateId={selectedTemplateId}
        />}

      {isModalConfirmationUnloadingl && (
        <ModalConfirmationUnloadingl
          setIsModal={setIsModalConfirmationUnloadingl}
        />
      )}

      {isModal &&
        <ModalNewScenario
          setScenarioData={setScenarioData}
          scenarioData={scenarioData}
          isEdit={isEditScenario}
          setIsModal={setIsModal}
          fetchRuleTable={fetchRuleTable}
          setIsEdit={setIsEditScenario}
        />
      }

      {isModalScenarioSettings &&
        <ModalScenarioSettings
          page={page}
          setIsModal={setIsModalScenarioSettings}
          selectedCategoryProperties={selectedCategoryProperties}
          setSelectedCategoryProperties={setSelectedCategoryProperties}
        />
      }

      {isModalMassEditing &&
        <ModalMassEditing
          createMassTemplate={createMassTemplate}
          setIsModal={setIsModalMassEditing}
          selectedGroup={selectedGroup}
          groupList={groupList}
          setSelectedGroupId={setSelectedGroupId}
          createTemplate={createTemplate}
          selectedGroupId={selectedGroupId}
        />
      }

      {isModalAddToGroup &&
        <ModalAddToGroup
          page={page}
          selectedGroupId={selectedGroupId}
          optionsGroup={optionsGroup}
          addToGroupTemplate={addToGroupTemplate}
          setArrCheck={setArrCheck}
          setIsModal={setIsModalAddToGroup}
        />
      }

      {isModalAddingReadyScenario &&
        <ModalAddingReadyScenario
          page={page}
          setIsModalScenarioSettings={setIsModalScenarioSettings}
          setIsModal={setIsModalAddingReadyScenario}
          setScenarioData={setScenarioData}
          scenarioData={scenarioData}
          setIsEdit={setIsEditScenario}
          isEdit={isEditScenario}
          fetchRuleTable={fetchRuleTable}
          selectedCategoryProperties={selectedCategoryProperties}
          setSelectedCategoryProperties={setSelectedCategoryProperties}
          isOpenItemsUser={isOpenItemsUser}
          setIsOpenItemsUser={setIsOpenItemsUser}
        />
      }

      <div className="automation-responses">
        <div className="content-1320">
          <TitlePage
            title={page == 'feedbacks' ? 'Автоматизация ответов' : 'Автоматизация вопросов'}
          />

          <Tabs
            query={location?.search}
            disabled={isNotOneAccount !== 'done'}
            tabs={btn_tab}
            pageValue={pageValue}
          />
        </div>

        {isNotOneAccount === 'waiting' ?
          <NoDataContent
            img={banner_no_data}
            title={'Подключение создано'}
            description={`Сбор и обработка информации займет до 24 часов.
                Пока мы настраиваем подключение, вы можете ознакомиться с инструкцией по разделу.`
            }
          />
          : isNotOneAccount === 'none' ?
            <NoDataContent
              img={banner_no_data}
              title="Нет активных подключений"
              description="Создайте подключение чтобы пользоваться всеми инструментами сервиса"
              child={
                <ButtonBasic
                  green
                  onClick={(e) => openConnectionModalById([1, 3])}
                  text="Новое подключение"
                  size="56px"
                />
              }
            />
            : (
              <>
                {pageValue == 'answer_templates' && view == 'Chat' && (
                  <div className="content-1320">
                    <div className="chat-review">
                      <div className="chat-review__left-content">
                        <div className="chat-review__toolbar-top">
                          {input_search('group')}
                        </div>

                        <div className="chat-review__toolbar-medium">
                          {sort_component('group')}

                          <ButtonBasic
                            whiteGreen
                            width="150px"
                            minWidth="150px"
                            text={`+ Новая группа`}
                            onClick={() => createGroup()}
                            style={{
                              color: '#00B45E'
                            }}
                          />
                        </div>

                        {/* Список шаблонов, левый контент*/}

                        <div className="template-content">
                          <div className="template-list">
                            {groupList?.length > 0 ? (
                              <>{group_list()}</>
                            ) : (
                              <div className="info-block">
                                <h5 className="title">
                                  Здесь пока нет шаблонов {is_answer ? 'ответов' : 'вопросов'}
                                </h5>
                                <p className="text">
                                  Создавайте группы и добавляйте в них шаблоны {is_answer ? 'ответов' : 'вопросов'}
                                </p>
                                <img
                                  className="info-block__img"
                                  src={banner_no_data}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="chat-review__right-content">
                        <div className="chat-review__toolbar-top">

                          {arrCheck.length > 0 ?
                            <div className='answer-templates__header-btn-group'>
                              <ButtonBasic
                                green
                                width="160px"
                                minWidth="160px"
                                text={`Скопировать ${arrCheck.length}`}
                                onClick={(e) => {
                                  setIsModalAddToGroup(true)
                                }}
                              />

                              <ButtonBasic
                                red
                                width="160px"
                                minWidth="160px"
                                text={`Удалить ${arrCheck.length}`}
                                onClick={(e) => {
                                  arrCheck.forEach((el) => {
                                    deleteTemplateInGroup(el)
                                  })
                                  setArrCheck([])
                                }}
                              />

                              <ButtonBasic
                                grey
                                width="auto"
                                text={`Отмена`}
                                style={{
                                  marginLeft: 'auto'
                                }}
                                onClick={(e) => setArrCheck([])}
                              />
                            </div>
                            :
                            <>
                              {input_search('message')}
                            </>
                          }
                        </div>

                        <div className="chat-review__toolbar-medium" >

                          {sort_component('message')}

                          <ButtonBasic
                            whiteGreen
                            width="180px"
                            minWidth="180px"
                            text={'+ Массовая загрузка'}
                            onClick={() => setIsModalMassEditing(true)}
                            style={{ color: '#00B45E' }}
                          />
                        </div>

                        <div className="chat">
                          {groupTemplates?.length < 1 ? (
                            <div className="info-block">
                              <h5 className="title">
                                Здесь пока нет шаблонов {is_answer ? 'ответов' : 'вопросов'}
                              </h5>
                              <p className="text">Создавайте шаблоны {is_answer ? 'ответов' : 'вопросов'}</p>
                              <img
                                className="info-block__img"
                                src={banner_no_data}
                              />
                            </div>
                          ) : (
                            <div className="chat__content">
                              {groupTemplates?.map(
                                ({ answer, id, created_at, updated_at }) => (
                                  <TemplateMessage
                                    key={answer + id}
                                    setCurrentId={(e) => setCurrentId(e)}
                                    selectedGroupId={selectedGroupId}
                                    pageValue2={pageValue2}
                                    pageValue3={pageValue3}
                                    arrCheck={arrCheck}
                                    setArrCheck={(e) => setArrCheck(e)}
                                    isActiveGroup={selectedGroupId}
                                    id={id}
                                    group_id={selectedGroupId}
                                    message={answer}
                                    created_at={created_at}
                                    editTemplate={editTemplate}
                                    setIsModalAddToGroup={(e) =>
                                      setIsModalAddToGroup(e)
                                    }
                                    showTransfer={pageValue3 !== 'in_group'}
                                    globalIsEdit={isEdit}
                                    setGlobalIsEdit={setIsEdit}
                                    setAnswer={setAnswer}
                                    setSelectedTemplateId={(e) => {
                                      setSelectedTemplateId(e);
                                    }}
                                    view={view}
                                    updated_at={updated_at}
                                    setIsModalConfirmingTemplateDeletion={(e) => setIsModalConfirmingTemplateDeletion(e)}
                                  />
                                )
                              )}
                            </div>
                          )}

                          <SendMessage
                            frequentAnswers
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            message={answer}
                            actionBtnText={isEdit ? 'Сохранить' : 'Создать'}
                            value={answerValue}
                            onChange={setAnswerValue}
                            onSendAction={(e) => {
                              if (isEdit) {
                                editTemplate(selectedTemplateId, answerValue);
                                setIsEdit(false);
                              } else {
                                if (selectedGroupId == -1) {
                                  createTemplate([answerValue])
                                } else {
                                  createMassTemplate(answerValue);
                                }
                              }
                              setAnswerValue('');
                            }}
                            showVariables={true}
                            varaibles={varaibles}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {(pageValue == 'prepared_scenarios' || pageValue == 'custom_scenarios') &&
                  <>



                    <TableBox
                      paginator={true}
                      ref={paginatorRef}
                      {...tableProps}
                      fetchCallback={(e) => fetchRuleTable(e)}
                      onAction={(e) => onEditRule(e)}
                      onToggle={(e) => onToggleStatus(e)}
                      contextMenuArr={contextMenuArr}
                      child={
                        <>
                          <ButtonBasic
                            green
                            width="auto"
                            text="Добавить сценарий"
                            size="32px"
                            onClick={(e) => {
                              if (pageValue == 'prepared_scenarios') {
                                setIsModalAddingReadyScenario(true);
                              } else {
                                setIsEditScenario(false);
                                setIsModal(true);
                              }
                            }}
                          />

                          <ButtonBasic
                            red
                            size="32px"
                            width='fit-content'
                            onClick={(e) => {
                              setCurrentFilterService(pageValue == 'custom_scenarios' ? 4 : 5)
                              setIsModalNotificationsError(true)
                            }}
                            text={`Ошибки - ${counterError?.[pageValue == 'custom_scenarios' ? 4 : 5] || 0}`}
                          />
                        </>
                      }
                    />

                  </>
                }
              </>
            )}
      </div>
    </>
  );
};

export { AutomationResponses };